// @ts-nocheck
import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Card, CardHeader, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useChart } from '../chart';
import { fShortenNumber } from '../../utils/formatNumber';
import { FeedbackSummary } from './types';

interface AnswerQualityChartProps {
  title: string;
  subheader?: string;
  data: FeedbackSummary;
  onFeedbackClick?: (feedbackType: string) => void;
}

export default function AnswerQualityChart({ title, subheader, data, onFeedbackClick }: AnswerQualityChartProps) {
  const theme = useTheme();

  const chartLabels = ['Good', 'Partially Wrong', 'Full Wrong', 'No Feedback', 'Other'];
  const feedbackKeys = ['good', 'partiallyCorrect', 'fullWrong', 'noFeedback', 'other'];
  const chartSeries = [data.good, data.partiallyCorrect, data.fullWrong, data.noFeedback, data.other ?? 0];

  const chartOptions = useChart({
    labels: chartLabels,
    colors: [
      theme.palette.success.main,
      theme.palette.warning.main,
      theme.palette.error.main,
      theme.palette.grey[400],
      theme.palette.info.main,
    ],
    chart: {
      events: {
        dataPointSelection: (_event, _chartContext, config) => {
          if (onFeedbackClick && config.dataPointIndex !== undefined && chartSeries[config.dataPointIndex] > 0) {
            onFeedbackClick(feedbackKeys[config.dataPointIndex]);
          }
        },
        legendClick: (_chartContext, seriesIndex) => {
          if (onFeedbackClick && seriesIndex !== undefined && chartSeries[seriesIndex] > 0) {
            onFeedbackClick(feedbackKeys[seriesIndex]);
          }
        },
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: '70%',
          labels: {
            show: true,
            total: {
              show: true,
              label: 'Total Feedback',
              fontSize: '13px',
              color: theme.palette.text.secondary,
              formatter: (w) => {
                const sum = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                return fShortenNumber(sum);
              },
            },
          },
        },
      },
    },
    stroke: { colors: [theme.palette.background.paper] },
    legend: {
      floating: false,
      position: 'bottom',
      horizontalAlign: 'center',
      fontSize: '12px',
      itemMargin: { horizontal: 8, vertical: 4 },
    },
    tooltip: {
      fillSeriesColor: false,
      y: {
        formatter: (val) => `${val} responses`,
        title: { formatter: (name) => `${name}` },
      },
    },
  });

  return (
    <Card>
      <CardHeader title={title} subheader={subheader} />
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart type="donut" series={chartSeries} options={chartOptions} height={320} />
      </Box>
    </Card>
  );
}
